import React from 'react';
import PropTypes from 'prop-types';

const SponsorshipCard = ({ tier }) => {
    return (
        <div className={`col-md-2 mb-4`}>
            <div className="sponsorship-card text-center">
                <div className="sponsorship-card-title">
                    {tier.name}
                </div>
                <div className="sponsorship-card-price">
                    ${tier.price}
                </div>
            </div>
        </div>
    );
};

SponsorshipCard.propTypes = {
    tier: PropTypes.shape({
        classNames: PropTypes.string,
        name: PropTypes.string,
        price: PropTypes.number,
        description: PropTypes.string,
    })
};

export default SponsorshipCard;